export default __webpack_public_path__ + "static/pc04-27f0d074312aee987123a40834b0be63.png";